export const PO_TRANSLATE = {
    "HELLO": "Olá",
    "back": "Voltar",
    "ok": "Ok",
    "cancel": "Cancelar",
    "startBtn": "Começar",

    "detox": "Desintoxicação",
    "detoxPlan": "Menus e Receitas",
    "settings": "Configurações",
    "shoppingList": "Lista de compras",
    "termsOfUse": "Termos de uso",
    "guides": "Guias",
    "aboutUs": "Sobre nós",
    "slogan": "21 dias de limpeza corporal saudável",

    "dailyMenu": "Menu diário",
    "day": "Dia",
    "finish": "E agora",
    "ingredients": "Ingredientes",
    "instructions": "Instruções",
    "intro": "Introdução",
    "markThisDay": "Marcar este dia como concluído",
    "serving": "Porção",
    "servings": "Porções",
    "meals": [
        {
            "name": "Café da manhã"
        },
        {
            "name": "Meio da manhã"
        },
        {
            "name": "Almoço"
        },
        {
            "name": "Meio da tarde"
        },
        {
            "name": "Jantar"
        }
    ],

    "more": "mais",
    "language": "Idioma",

    "he": "עברית",
    "en": "English",
    "ge": "Deutsch",
    "ru": "русский",
    "fr": "français",
    "sp": "español",
    "po": "português",

    "unit": "Unidade",
    "selectDetoxPlan": "Selecione seu plano de desintoxicação",
    "detoxPlans": "Planos de desintoxicação",
    "restart": "Reiniciar",
    "start": "Começar",
    "days": "dias",
    "standard": "padrão",
    "vegan": "vegano",
    "vegetarian": "vegetariano",
    "pescetarian": "pescetariano",
    "wellDone": "Bem feito!",
    "whatsNow": "E agora",

    "youDidIt": "Bem feito, você conseguiu",
    "weProud": "Estamos orgulhosos de você,",
    "presentYourself": "Você se deu um presente incrível",

    "messages": {
        "resetApp": {
            "title": "Reiniciar o aplicativo",
            "content": "Esta ação irá redefinir a lista de compras e os dias marcados como concluídos.\nPressione OK se você deseja reiniciar o aplicativo."
        }
    },
}
